<!-- reset-password.component.html -->

 <section id="content">
    <form id="form">
<div class="reset-password-container">
    <p-card header="Reset Password" class="reset-password-card">
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
        <div class="p-fluid">

          <div class="p-field">
            <label for="newPassword">Old Password</label>
            <p-password id="oldPassword" [toggleMask]="true" [feedback]="false" formControlName="oldPassword"
            [ngClass]="{
              'ng-invalid ng-dirty': oldPasswordErrorMessage
            }"
             />
           
            <small *ngIf="resetPasswordForm.get('oldPassword').invalid && resetPasswordForm.get('oldPassword')?.touched" class="p-error">
                Old Password is required.
             
            </small>
            
            <small
            *ngIf="oldPasswordErrorMessage != null " class="p-error">
             {{ oldPasswordErrorMessage }}
            
            </small>
            
          </div>

          <div class="p-field">
            <label for="newPassword">New Password</label>
            <p-password [toggleMask]="true"  id="newPassword" formControlName="newPassword" />
            <small *ngIf="resetPasswordForm.get('newPassword').invalid && resetPasswordForm.get('newPassword')?.touched" class="p-error">
              New Password is required.
           
          </small>
            
          </div>
  
          <div class="p-field">
            <label for="confirmPassword">Confirm Password</label>
            <input pInputText type="password" id="confirmPassword" formControlName="confirmPassword" />
            <small *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.['mismatch'] && resetPasswordForm.get('confirmPassword')?.touched" class="p-error">
                Passwords must match.
              </small>
              
          </div>
  
          <div class="p-mt-3 text-center">
            <button pButton type="submit" label="Reset Password" [disabled]="resetPasswordForm.invalid"></button>
          </div>
        </div>
      </form>
    </p-card>
  </div>

</form>
</section>

